var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-wizard",class:_vm.bemFacets},[_c('div',{staticClass:"map-wizard__navigation"},[_vm._t("navigation")],2),_vm._v(" "),_c('div',{staticClass:"map-wizard__configurator"},[_vm._t("step")],2),_vm._v(" "),_c('div',{staticClass:"map-wizard__viewer"},[_vm._t("map")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }